import Faded from '@/components/templates/animated/faded'
import { device } from '@/components/templates/displays/devices'
import React from 'react'
import { ICar, IGalleryImage } from 'shared-interfaces'
import styled from 'styled-components'
import GarageDuoGrid from '../grids/imagesGrid/duoGrid'
import GarageBannerViewDesktop from '../lists/imageLists/garageBannerViewDesktop'

const Container = styled.div`
    width: 100%;
    @media ${device.mobile} {
        margin-top: 6px;
    }

    @media ${device.desktop} {
        margin-top: 10px;
    }
`

interface Props {
    carsIdList: any
    carsData: any
    get_cover_img: (car: ICar) => IGalleryImage | undefined
    activeView: string
    areCarsLoading: boolean
    garage_link_id: any
}

type State = {
    carsDataFinished: null | {}
}
class GarageViewManagerDesktop extends React.Component<Props, State> {
    state = {
        carsDataFinished: null,
    }

    componentDidMount() {}

    renderRightView = (activeView: string) => {
        if (activeView === 'banner_view') {
            return (
                <Faded>
                    {this.props.carsIdList.map(
                        (carid: string, index: number) => {
                            let car = this.props.carsData[carid]
                            if (car) {
                                return (
                                    <Faded key={index}>
                                        <GarageBannerViewDesktop
                                            carObject={{
                                                ...this.props.carsData[carid],
                                            }}
                                            cover_img={this.props.get_cover_img(
                                                this.props.carsData[carid]
                                            )}
                                            linkToCar={`/garage/${this.props.garage_link_id}/car/${carid}/overview`}
                                            dataAttId="garage_banner_item_desktop"
                                        />
                                    </Faded>
                                )
                            }
                        }
                    )}
                </Faded>
            )
        } else if (activeView === 'grid_view') {
            return (
                <GarageDuoGrid
                    cars_ids_list={this.props.carsIdList}
                    carsData={this.props.carsData}
                    garage_link_id={this.props.garage_link_id}
                    get_cover_img={this.props.get_cover_img}
                />
            )
        }
    }

    render() {
        const { areCarsLoading, activeView } = this.props

        return (
            <Container>
                {areCarsLoading !== true && this.renderRightView(activeView)}
            </Container>
        )
    }
}

export default GarageViewManagerDesktop
